import React, {
  createContext,
  Dispatch,
  memo,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react'

export type UserContextValue = {
  connection: ConnectionStatus
  setConnection: Dispatch<SetStateAction<ConnectionStatus>>
}

export type ConnectionStatus = 'connected' | 'disconnected' | 'connecting'

const UserContext = createContext<UserContextValue>(null as any)

export function useUser() {
  const ctx = useContext(UserContext)
  if (!ctx) {
    throw new Error('useUser must be used within a UserContextProvider')
  }

  return ctx
}

const UserContextProvider = memo(({ children }: { children: ReactNode }) => {
  const [connection, setConnection] = useState<ConnectionStatus>('disconnected')

  const userContext = useMemo<UserContextValue>(
    () => ({
      connection,
      setConnection,
    }),
    [connection, setConnection]
  )

  return <UserContext.Provider value={userContext}>{children}</UserContext.Provider>
})
UserContextProvider.displayName = 'UserContextProvider'

export default UserContextProvider
